import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {BusinessUnitDetail} from "./business-unit-detail";

const BusinessUnitDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/businessunits');
    }

    return (
        <BusinessUnitDetail id={id ? parseInt(id) : null} onClose={onClose}/>
    )

});

export default BusinessUnitDetailPage;
